/**
 * AdminOpsTab — iter87.199.81
 *
 * Site Admin → Admin Ops surface. Three sub-tabs with URL persistence:
 *   - llm     → LLM Monitor (lift & shift of the existing tab)
 *   - email   → Email templates catalog + preview
 *   - scoring → Scoring registry viewer + copy catalog
 *
 * URL sync: `?tab=admin_ops&sub={llm|email|scoring}`. Reload / share-
 * link land on the right sub-tab.
 */
import React, { useEffect, useState } from "react";
import { Sparkles, Mail, Trophy } from "lucide-react";
import LLMMonitorTab from "./LLMMonitorTab";
import EmailTemplatesCatalog from "./EmailTemplatesCatalog";
import ScoringMonitor from "./ScoringMonitor";

const SUBS = [
    { k: "llm",     label: "LLM Monitor",       icon: Sparkles, Component: LLMMonitorTab },
    { k: "email",   label: "Email Monitor",     icon: Mail,     Component: EmailTemplatesCatalog },
    { k: "scoring", label: "Scoring Monitor",   icon: Trophy,   Component: ScoringMonitor },
];

export default function AdminOpsTab() {
    const [sub, setSub] = useState(() => {
        try {
            const p = new URLSearchParams(window.location.search);
            const s = p.get("sub");
            return SUBS.some((x) => x.k === s) ? s : "llm";
        } catch { return "llm"; }
    });
    useEffect(() => {
        try {
            const p = new URLSearchParams(window.location.search);
            p.set("sub", sub);
            const next = `${window.location.pathname}?${p.toString()}${window.location.hash || ""}`;
            window.history.replaceState(null, "", next);
        } catch { /* no-op */ }
    }, [sub]);
    const Active = (SUBS.find((s) => s.k === sub) || SUBS[0]).Component;
    return (
        <div className="space-y-4" data-testid="admin-ops-tab">
            <div className="border-b-2 border-zinc-800 pb-3 mb-1">
                <p className="text-[10px] uppercase tracking-[0.3em] text-volt font-black">Admin Ops</p>
                <h1 className="font-display font-black text-2xl tracking-tight">Comms Monitor</h1>
                <p className="text-xs text-zinc-500 leading-snug mt-1">
                    Read-only view of every LLM output, email, and scoring copy that leaves the platform.
                </p>
            </div>
            <div className="flex flex-wrap gap-2 border-b-2 border-zinc-800 pb-2">
                {SUBS.map(({ k, label, icon: Icon }) => (
                    <button
                        key={k}
                        onClick={() => setSub(k)}
                        data-testid={`admin-ops-subtab-${k}`}
                        className={`inline-flex items-center gap-1.5 pill text-xs font-black uppercase tracking-widest px-3 py-1.5 ${
                            sub === k
                                ? "bg-volt text-black border-volt"
                                : "bg-transparent text-zinc-400 border-[#333] hover:text-white hover:border-white/40"
                        }`}
                    >
                        <Icon className="w-3.5 h-3.5" /> {label}
                    </button>
                ))}
            </div>
            <Active />
        </div>
    );
}
